import script from "./FilesUploadModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./FilesUploadModal.vue?vue&type=script&setup=true&lang=ts"

import "./FilesUploadModal.vue?vue&type=style&index=0&id=276c3fa8&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-276c3fa8"]])

export default __exports__